import React from "react";

import { Link } from "react-router-dom"

import { sayHi } from "@/utils"

import CommonLayout from "@/common/Layout"

import image01 from "@/assets/images/1.jpg"
import image07 from "@/assets/images/7.jpg"

function IndexPage(props) {

    sayHi()

    return (
        <CommonLayout>
            <h1>TestPage</h1>
            <div style={{ margin: "16px 0" }}>
                <Link to="/">首页</Link>
            </div>
            <div style={{ margin: "16px 0" }}>
                <img src={image07} style={{ width: 300, height: 180 }} alt="" />
            </div>
            <div style={{ margin: "16px 0" }}>
                <div style={{ width: 300, height: 180, backgroundImage: `url(${image01})` }}></div>
            </div>
        </CommonLayout>
    )
}

export default IndexPage